import React from "react";
import PropTypes from "prop-types";

const SectionHeader = ({ title }) => (
  <div className="SectionHeader bg-primary px-2 py-1 text-white font-semibold">{title}</div>
);

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired
};

export default SectionHeader;
